import { render, staticRenderFns } from "./SubBaseTable.vue?vue&type=template&id=1eaece12&"
import script from "./SubBaseTable.vue?vue&type=script&lang=js&"
export * from "./SubBaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports